<div class="modal-header">
  <h3>
    {{ TradeSpecialtyCategory && TradeSpecialtyCategory.id ? 'Edit' : 'Add' }}
    Trade Specialty Category
  </h3>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close('Cross Click')"
  ></button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col">
      <form [formGroup]="TradeSpecialtyCategoryForm">
        <div class="row g-3">
          <div class="col-6">
            <div class="form-group">
              <label for="PrimaryTradeId" class="form-label" requiredAsterisk
                >Trade Name</label
              >
              <select
                id="PrimaryTradeId"
                class="form-select"
                formControlName="PrimaryTradeId"
              >
                <option [ngValue]="null" selected disabled>Pick one...</option>
                @for (trade of trades; track trade) {
                  <option [ngValue]="trade.id">
                    {{ trade.name }}
                  </option>
                }
              </select>
            </div>
          </div>

          <div class="col-6">
            <div class="form-group">
              <label for="TradeCategoryId" class="form-label" requiredAsterisk
                >Category Name</label
              >
              <select
                id="TradeCategoryId"
                class="form-select"
                formControlName="TradeCategoryId"
              >
                <option [ngValue]="null" selected disabled>Pick one...</option>
                @for (category of categories; track category) {
                  <option [ngValue]="category.id">
                    {{ category.categoryName }}
                  </option>
                }
              </select>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<div class="modal-footer">
  <div class="row w-100 justify-content-end">
    <div class="col-3">
      <button class="btn btn-danger" (click)="close('Close')">Close</button>
    </div>
    <div class="col-3">
      <button class="btn btn-primary" (click)="save()">Save</button>
    </div>
  </div>
</div>
